
import React from 'react';
import { Badge } from "@/components/ui/badge";
import { Tag } from 'lucide-react';

interface CommentTopicsProps {
  topics?: string[];
}

const CommentTopics: React.FC<CommentTopicsProps> = ({ topics }) => {
  if (!topics || topics.length === 0) return null;
  
  return (
    <div className="flex flex-wrap gap-1 mt-2">
      {topics.map(topic => (
        <Badge key={topic} variant="secondary" className="text-xs px-2 py-0">
          <Tag className="h-3 w-3 mr-1" />
          {topic}
        </Badge>
      ))}
    </div>
  );
};

export default CommentTopics;
